// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-interface {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #ffffff;
}

/* 聊天头部 */
.chat-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: linear-gradient(90deg, #f0f9ff 0%, #e0f2fe 100%);
  border-bottom: 1px solid #e6f7ff;
}

.chat-title {
  flex: 1 1;
}

/* 消息容器 */
.messages-container {
  flex: 1 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.messages-list {
  flex: 1 1;
  overflow-y: auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* 消息项 */
.message-item {
  display: flex;
  gap: 12px;
  max-width: 100%;
}

.user-message {
  flex-direction: row-reverse;
}

.doctor-message {
  flex-direction: row;
}

.message-avatar {
  flex-shrink: 0;
}

.message-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  max-width: calc(100% - 60px);
  white-space: pre-wrap;   /* 保留 \\n 与多空格 */
  word-break: break-word;  /* 长词换行 */
}

.user-message .message-content {
  align-items: flex-end;
}

.doctor-message .message-content {
  align-items: flex-start;
}

.message-header {
  margin-bottom: 4px;
}

/* 消息气泡 */
.message-bubble {
  position: relative;
  padding: 12px 16px;
  border-radius: 18px;
  max-width: 100%;
  word-wrap: break-word;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.user-bubble {
  background: linear-gradient(135deg, #285C4D 0%, #285C4D 100%);
  color: white;
  border-bottom-right-radius: 6px;
}

.doctor-bubble {
  background: linear-gradient(135deg, #f6ffed 0%, #f0f9ff 100%);
  color: #262626;
  border: 1px solid #d9f7be;
  border-bottom-left-radius: 6px;
}

.error-bubble {
  background: linear-gradient(135deg, #fff2f0 0%, #ffebe6 100%);
  border: 1px solid #ffccc7;
  color: #cf1322;
}

.message-text {
  margin: 0;
  font-family: inherit;
  white-space: pre-wrap;
  line-height: 1.5;
}

/* Markdown overrides */
.markdown-body {
  white-space: normal; /* markdown需要正常换行，由内部 <p> 处理 */
}
.markdown-body p {
  margin: 0 0 0.6em;
}
.markdown-body p:last-child { margin-bottom: 0; }
.markdown-body code {
  background: rgba(0,0,0,0.06);
  padding: 2px 5px;
  border-radius: 4px;
  font-size: 90%;
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace;
}
.markdown-body pre {
  background: #1e1e1e;
  color: #f5f5f5;
  padding: 10px 12px;
  border-radius: 8px;
  overflow-x: auto;
  line-height: 1.45;
  margin: 0.5em 0;
}
.markdown-body pre code {
  background: transparent;
  padding: 0;
  color: inherit;
  font-size: 13px;
}
.markdown-body blockquote {
  margin: 0.5em 0;
  padding: 6px 10px 6px 14px;
  background: #f6f8fa;
  border-left: 4px solid #285C4D;
  border-radius: 4px;
  color: #555;
}
.markdown-body ul,
.markdown-body ol {
  padding-left: 1.4em;
  margin: 0.4em 0 0.6em;
}
.markdown-body li {
  margin: 0.2em 0;
}
.markdown-body hr {
  border: none;
  border-top: 1px solid #e8e8e8;
  margin: 1em 0;
}
.markdown-body table {
  border-collapse: collapse;
  font-size: 13px;
  width: 100%;
}
.markdown-body th, .markdown-body td {
  border: 1px solid #e0e0e0;
  padding: 6px 8px;
  text-align: left;
}
.markdown-body thead th {
  background: #fafafa;
}
.md-table-wrapper {
  overflow-x: auto;
  margin: 0.5em 0;
}
.markdown-body a {
  color: #285C4D;
  text-decoration: none;
}
.markdown-body a:hover {
  text-decoration: underline;
}

.message-time {
  font-size: 11px;
  opacity: 0.7;
  margin-top: 6px;
  text-align: right;
}

.user-bubble .message-time {
  color: rgba(255, 255, 255, 0.8);
}

/* 打字指示器 */
.typing-indicator {
  display: flex;
  gap: 12px;
  align-items: center;
  opacity: 0.8;
}

.typing-bubble {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background: #f0f0f0;
  border-radius: 16px;
  color: #666;
}

/* 快速问题 */
.quick-questions {
  padding: 16px 20px;
  background: #fafafa;
  border-top: 1px solid #f0f0f0;
}

.quick-question-tag {
  cursor: pointer;
  transition: all 0.3s;
  border: 1px solid #d9d9d9;
  background: white;
  color: #666;
}

quick-question-tag:hover {
  border-color: #285C4D;
  color: #285C4D;
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(40, 92, 77, 0.18);
}

/* 输入区域 */
.chat-input {
  border-top: 1px solid #f0f0f0;
  background: white;
}

.input-container {
  display: flex;
  gap: 8px;
  padding: 16px 20px;
  align-items: flex-end;
}

.message-input {
  flex: 1 1;
  border-radius: 20px;
  border: 1px solid #d9d9d9;
  padding: 8px 16px;
}

.message-input:focus,
.message-input:hover {
  border-color: #285C4D;
  box-shadow: 0 0 0 2px rgba(40, 92, 77, 0.12);
}

.send-button {
  border-radius: 20px;
  height: auto;
  padding: 8px 20px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.input-footer {
  padding: 0 20px 12px;
  text-align: center;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .messages-list {
    padding: 16px;
    gap: 12px;
  }
  
  .message-content {
    max-width: calc(100% - 50px);
  }
  
  .message-bubble {
    padding: 10px 14px;
    border-radius: 16px;
  }
  
  .chat-header {
    padding: 12px 16px;
  }
  
  .input-container {
    padding: 12px 16px;
  }
  
  .quick-questions {
    padding: 12px 16px;
  }
}

/* 滚动条样式 */
.messages-list::-webkit-scrollbar {
  width: 4px;
}

.messages-list::-webkit-scrollbar-track {
  background: transparent;
}

.messages-list::-webkit-scrollbar-thumb {
  background: #d9d9d9;
  border-radius: 2px;
}

.messages-list::-webkit-scrollbar-thumb:hover {
  background: #bfbfbf;
}

/* 动画效果 */
.message-item {
  animation: messageSlideIn 0.3s ease-out;
}

@keyframes messageSlideIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.typing-indicator {
  animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.message-image {
  max-width: 260px;
  max-height: 200px;
  border-radius: 8px;
  display: block;
}
`, "",{"version":3,"sources":["webpack://./src/components/ChatInterface.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,4DAA4D;EAC5D,gCAAgC;AAClC;;AAEA;EACE,SAAO;AACT;;AAEA,SAAS;AACT;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,QAAQ;AACR;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,qBAAqB,IAAI,eAAe;EACxC,sBAAsB,GAAG,SAAS;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB,EAAE,8BAA8B;AACrD;AACA;EACE,iBAAiB;AACnB;AACA,8BAA8B,gBAAgB,EAAE;AAChD;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,4EAA4E;AAC9E;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,UAAU;EACV,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;AACb;AACA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;EACZ,6BAA6B;EAC7B,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;AACjC;;AAEA,UAAU;AACV;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA,SAAS;AACT;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA,UAAU;AACV;EACE;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,UAAU;AACV;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,uCAAuC;AACzC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB","sourcesContent":[".chat-interface {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background: #ffffff;\n}\n\n/* 聊天头部 */\n.chat-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  background: linear-gradient(90deg, #f0f9ff 0%, #e0f2fe 100%);\n  border-bottom: 1px solid #e6f7ff;\n}\n\n.chat-title {\n  flex: 1;\n}\n\n/* 消息容器 */\n.messages-container {\n  flex: 1;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.messages-list {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* 消息项 */\n.message-item {\n  display: flex;\n  gap: 12px;\n  max-width: 100%;\n}\n\n.user-message {\n  flex-direction: row-reverse;\n}\n\n.doctor-message {\n  flex-direction: row;\n}\n\n.message-avatar {\n  flex-shrink: 0;\n}\n\n.message-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  max-width: calc(100% - 60px);\n  white-space: pre-wrap;   /* 保留 \\n 与多空格 */\n  word-break: break-word;  /* 长词换行 */\n}\n\n.user-message .message-content {\n  align-items: flex-end;\n}\n\n.doctor-message .message-content {\n  align-items: flex-start;\n}\n\n.message-header {\n  margin-bottom: 4px;\n}\n\n/* 消息气泡 */\n.message-bubble {\n  position: relative;\n  padding: 12px 16px;\n  border-radius: 18px;\n  max-width: 100%;\n  word-wrap: break-word;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n.user-bubble {\n  background: linear-gradient(135deg, #285C4D 0%, #285C4D 100%);\n  color: white;\n  border-bottom-right-radius: 6px;\n}\n\n.doctor-bubble {\n  background: linear-gradient(135deg, #f6ffed 0%, #f0f9ff 100%);\n  color: #262626;\n  border: 1px solid #d9f7be;\n  border-bottom-left-radius: 6px;\n}\n\n.error-bubble {\n  background: linear-gradient(135deg, #fff2f0 0%, #ffebe6 100%);\n  border: 1px solid #ffccc7;\n  color: #cf1322;\n}\n\n.message-text {\n  margin: 0;\n  font-family: inherit;\n  white-space: pre-wrap;\n  line-height: 1.5;\n}\n\n/* Markdown overrides */\n.markdown-body {\n  white-space: normal; /* markdown需要正常换行，由内部 <p> 处理 */\n}\n.markdown-body p {\n  margin: 0 0 0.6em;\n}\n.markdown-body p:last-child { margin-bottom: 0; }\n.markdown-body code {\n  background: rgba(0,0,0,0.06);\n  padding: 2px 5px;\n  border-radius: 4px;\n  font-size: 90%;\n  font-family: \"SFMono-Regular\", Consolas, \"Liberation Mono\", Menlo, monospace;\n}\n.markdown-body pre {\n  background: #1e1e1e;\n  color: #f5f5f5;\n  padding: 10px 12px;\n  border-radius: 8px;\n  overflow-x: auto;\n  line-height: 1.45;\n  margin: 0.5em 0;\n}\n.markdown-body pre code {\n  background: transparent;\n  padding: 0;\n  color: inherit;\n  font-size: 13px;\n}\n.markdown-body blockquote {\n  margin: 0.5em 0;\n  padding: 6px 10px 6px 14px;\n  background: #f6f8fa;\n  border-left: 4px solid #285C4D;\n  border-radius: 4px;\n  color: #555;\n}\n.markdown-body ul,\n.markdown-body ol {\n  padding-left: 1.4em;\n  margin: 0.4em 0 0.6em;\n}\n.markdown-body li {\n  margin: 0.2em 0;\n}\n.markdown-body hr {\n  border: none;\n  border-top: 1px solid #e8e8e8;\n  margin: 1em 0;\n}\n.markdown-body table {\n  border-collapse: collapse;\n  font-size: 13px;\n  width: 100%;\n}\n.markdown-body th, .markdown-body td {\n  border: 1px solid #e0e0e0;\n  padding: 6px 8px;\n  text-align: left;\n}\n.markdown-body thead th {\n  background: #fafafa;\n}\n.md-table-wrapper {\n  overflow-x: auto;\n  margin: 0.5em 0;\n}\n.markdown-body a {\n  color: #285C4D;\n  text-decoration: none;\n}\n.markdown-body a:hover {\n  text-decoration: underline;\n}\n\n.message-time {\n  font-size: 11px;\n  opacity: 0.7;\n  margin-top: 6px;\n  text-align: right;\n}\n\n.user-bubble .message-time {\n  color: rgba(255, 255, 255, 0.8);\n}\n\n/* 打字指示器 */\n.typing-indicator {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  opacity: 0.8;\n}\n\n.typing-bubble {\n  display: flex;\n  align-items: center;\n  padding: 8px 12px;\n  background: #f0f0f0;\n  border-radius: 16px;\n  color: #666;\n}\n\n/* 快速问题 */\n.quick-questions {\n  padding: 16px 20px;\n  background: #fafafa;\n  border-top: 1px solid #f0f0f0;\n}\n\n.quick-question-tag {\n  cursor: pointer;\n  transition: all 0.3s;\n  border: 1px solid #d9d9d9;\n  background: white;\n  color: #666;\n}\n\nquick-question-tag:hover {\n  border-color: #285C4D;\n  color: #285C4D;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 6px rgba(40, 92, 77, 0.18);\n}\n\n/* 输入区域 */\n.chat-input {\n  border-top: 1px solid #f0f0f0;\n  background: white;\n}\n\n.input-container {\n  display: flex;\n  gap: 8px;\n  padding: 16px 20px;\n  align-items: flex-end;\n}\n\n.message-input {\n  flex: 1;\n  border-radius: 20px;\n  border: 1px solid #d9d9d9;\n  padding: 8px 16px;\n}\n\n.message-input:focus,\n.message-input:hover {\n  border-color: #285C4D;\n  box-shadow: 0 0 0 2px rgba(40, 92, 77, 0.12);\n}\n\n.send-button {\n  border-radius: 20px;\n  height: auto;\n  padding: 8px 20px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.input-footer {\n  padding: 0 20px 12px;\n  text-align: center;\n}\n\n/* 响应式设计 */\n@media (max-width: 768px) {\n  .messages-list {\n    padding: 16px;\n    gap: 12px;\n  }\n  \n  .message-content {\n    max-width: calc(100% - 50px);\n  }\n  \n  .message-bubble {\n    padding: 10px 14px;\n    border-radius: 16px;\n  }\n  \n  .chat-header {\n    padding: 12px 16px;\n  }\n  \n  .input-container {\n    padding: 12px 16px;\n  }\n  \n  .quick-questions {\n    padding: 12px 16px;\n  }\n}\n\n/* 滚动条样式 */\n.messages-list::-webkit-scrollbar {\n  width: 4px;\n}\n\n.messages-list::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.messages-list::-webkit-scrollbar-thumb {\n  background: #d9d9d9;\n  border-radius: 2px;\n}\n\n.messages-list::-webkit-scrollbar-thumb:hover {\n  background: #bfbfbf;\n}\n\n/* 动画效果 */\n.message-item {\n  animation: messageSlideIn 0.3s ease-out;\n}\n\n@keyframes messageSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.typing-indicator {\n  animation: fadeIn 0.3s ease-out;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.message-image {\n  max-width: 260px;\n  max-height: 200px;\n  border-radius: 8px;\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
